import { Routes, Navigate, Route } from "react-router-dom";
import { isEmpty } from "lodash";

import UserLayout from "../../layouts/UserLayout/UserLayout";
import DashboardUser from "../../pages/User/DashboardUser/DashboardUser";
import DashboardUserContext from "../../context/UserContext/DashboardUserContext/DashboardUserContext";
import ProfileUser from "../../pages/User/ProfileUser/ProfileUser";
import ProfileUserContext from "../../context/UserContext/ProfileUserContext/ProfileUserContext";
import UsersAdmin from "../../pages/Admin/UsersAdmin/UsersAdmin";
import UserAdminContext from "../../context/AdminContext/UserAdminContext/UserAdminContext";
import NotificationsUser from "../../pages/User/NotificationsUser/NotificationsUser";
import NotificationUserContext from "../../context/UserContext/NotificationUserContext/NotificationUserContext";
import TransactionsUser from "../../pages/User/TransactionsUser/TransactionsUser";
import TransactionUserContext from "../../context/UserContext/TransactionUserContext/TransactionUserContext";
import SettingAdmin from "../../pages/Admin/SettingAdmin/SettingAdmin";
import SettingAdminContext from "../../context/AdminContext/SettingAdminContext/SettingAdminContext";
import LogsAdmin from "../../pages/Admin/LogsAdmin/LogsAdmin";
import LogAdminContext from "../../context/AdminContext/LogAdminContext/LogAdminContext";
import GeoAdmin from "../../pages/Admin/GeoAdmin/GeoAdmin";
import GeoAdminContext from "../../context/AdminContext/GeoAdminContext/GeoAdminContext";
import TicketsUser from "../../pages/User/TicketsUser/TicketsUser";
import TicketUserContext from "../../context/UserContext/TicketUserContext/TicketUserContext";
import CategoriesAdmin from "../../pages/Admin/CategoriesAdmin/CategoriesAdmin";
import CategoryAdminContext from "../../context/AdminContext/CategoryAdminContext/CategoryAdminContext";
import FieldsAdmin from "../../pages/Admin/FieldsAdmin/FieldsAdmin";
import FieldAdminContext from "../../context/AdminContext/FieldAdminContext/FieldAdminContext";
import ProductsAdmin from "../../pages/Admin/ProductsAdmin/ProductsAdmin";
import ProductAdminContext from "../../context/AdminContext/ProductAdminContext/ProductAdminContext";
import OrdersUser from "../../pages/User/OrdersUser/OrdersUser";
import OrderUserContext from "../../context/UserContext/OrderUserContext/OrderUserContext";
import DiscountCodesAdmin from "../../pages/Admin/DiscountCodesAdmin/DiscountCodesAdmin";
import DiscountCodeAdminContext from "../../context/AdminContext/DiscountCodeAdminContext/DiscountCodeAdminContext";
import InvoicesUser from "../../pages/User/InvoicesUser/InvoicesUser";
import InvoiceUserContext from "../../context/UserContext/InvoiceUserContext/InvoiceUserContext";
import RenewalsUser from "../../pages/User/RenewalsUser/RenewalsUser";
import RenewalUserContext from "../../context/UserContext/RenewalUserContext/RenewalUserContext";
import FAQsAdmin from "../../pages/Admin/FAQsAdmin/FAQsAdmin";
import FAQAdminContext from "../../context/AdminContext/FAQAdminContext/FAQAdminContext";
import FAQPublic from "../../pages/Public/FAQPublic/FAQPublic";
import TermsPublic from "../../pages/Public/TermsPublic/TermsPublic";
import AboutUsPublic from "../../pages/Public/AboutUsPublic/AboutUsPublic";
import BulkSMSsAdmin from "../../pages/Admin/BulkSMSsAdmin/BulkSMSsAdmin";
import BulkSMSAdminContext from "../../context/AdminContext/BulkSMSAdminContext/BulkSMSAdminContext";
import CategoriesPublic from "../../pages/Public/CategoriesPublic/CategoriesPublic";
import CategoryPublicContext from "../../context/PublicContext/CategoryPublicContext/CategoryPublicContext";
import ProductPublic from "../../pages/Public/ProductPublic/ProductPublic";
import ProductsPublic from "../../pages/Public/ProductsPublic/ProductsPublic";
import ProductPublicContext from "../../context/PublicContext/ProductPublicContext/ProductPublicContext";
import PaymentsUser from "../../pages/User/PaymentsUser/PaymentsUser";
import PaymentUserContext from "../../context/UserContext/PaymentUserContext/PaymentUserContext";
import NotFoundPage from "./../../pages/Page/NotFoundPage/NotFoundPage";
import { decodeJWT, getCookies } from "../../utils";
import { userRoleItems } from "../../utils/enum";

const AdminContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  const roleName = decodeJWT(accessToken)?.role;

  if (!isLogin || roleName !== userRoleItems[0])
    return <Navigate to="/" replace />;

  return (
    <UserLayout>
      <Routes>
        {/* Dashboard */}
        <Route
          index
          element={
            <DashboardUserContext>
              <DashboardUser />
            </DashboardUserContext>
          }
        />

        {/* Notifications */}
        <Route
          path="/notifications"
          element={
            <NotificationUserContext>
              <NotificationsUser />
            </NotificationUserContext>
          }
        />

        {/* Users */}
        <Route
          path="/users"
          element={
            <UserAdminContext>
              <UsersAdmin />
            </UserAdminContext>
          }
        />

        {/* Fields */}
        <Route
          path="/fields"
          element={
            <FieldAdminContext>
              <FieldsAdmin />
            </FieldAdminContext>
          }
        />

        {/* Setting */}
        <Route
          path="/setting"
          element={
            <SettingAdminContext>
              <SettingAdmin />
            </SettingAdminContext>
          }
        />

        {/* Products */}
        {["/products", "/products/:category/category"].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProductAdminContext>
                <ProductsAdmin />
              </ProductAdminContext>
            }
          />
        ))}

        {/* Logs */}
        {["/logs", "/logs/:user/user"].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <LogAdminContext>
                <LogsAdmin />
              </LogAdminContext>
            }
          />
        ))}

        {/* Transactions */}
        {["/transactions", "/transactions/:user/user"].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <TransactionUserContext>
                <TransactionsUser />
              </TransactionUserContext>
            }
          />
        ))}

        {/* Profile */}
        {["/profile", "/profile/changed-password", "/profile/settings"].map(
          (key) => (
            <Route
              key={key}
              path={key}
              element={
                <ProfileUserContext>
                  <ProfileUser />
                </ProfileUserContext>
              }
            />
          )
        )}

        {/* Tickets */}
        {["/tickets", "/tickets/:id"].map((key) => (
          <Route
            key={key}
            path={key}
            element={
              <TicketUserContext>
                <TicketsUser />
              </TicketUserContext>
            }
          />
        ))}

        {/* Geo */}
        <Route
          path="/geo"
          element={
            <GeoAdminContext>
              <GeoAdmin />
            </GeoAdminContext>
          }
        />

        {/* Categories */}
        <Route
          path="/categories"
          element={
            <CategoryAdminContext>
              <CategoriesAdmin />
            </CategoryAdminContext>
          }
        />

        {/* FAQs */}
        <Route
          path="/faqs"
          element={
            <FAQAdminContext>
              <FAQsAdmin />
            </FAQAdminContext>
          }
        />

        {/* Orders */}
        {[
          "/orders",
          "/orders/:user/user",
          "/orders/:product/product",
          "/orders/:invoice/invoice",
        ].map((path) => (
          <Route
            path={path}
            element={
              <OrderUserContext>
                <OrdersUser />
              </OrderUserContext>
            }
          />
        ))}

        {/* Discount Codes */}
        {[
          "/discount-code",
          "/discount-code/:user/user",
          "/discount-code/:product/product",
          "/discount-code/:category/category",
        ].map((path) => (
          <Route
            path={path}
            element={
              <DiscountCodeAdminContext>
                <DiscountCodesAdmin />
              </DiscountCodeAdminContext>
            }
          />
        ))}

        {/* Invoices */}
        {["/invoices", "/invoices/:user/user"].map((path) => (
          <Route
            path={path}
            element={
              <InvoiceUserContext>
                <InvoicesUser />
              </InvoiceUserContext>
            }
          />
        ))}

        {/* Renewals */}
        {[
          "/renewals",
          "/renewals/:user/user",
          "/renewals/:order/order",
          "/renewals/:invoice/invoice",
        ].map((path) => (
          <Route
            path={path}
            element={
              <RenewalUserContext>
                <RenewalsUser />
              </RenewalUserContext>
            }
          />
        ))}

        {/* FAQ */}
        <Route path="/faq" element={<FAQPublic />} />

        {/* Terms */}
        <Route path="/terms" element={<TermsPublic />} />

        {/* About Us */}
        <Route path="/about-us" element={<AboutUsPublic />} />

        {/* Bulk SMS */}
        <Route
          path="/bulk-sms"
          element={
            <BulkSMSAdminContext>
              <BulkSMSsAdmin />
            </BulkSMSAdminContext>
          }
        />

        {/* Category */}
        {["/category", "/category/:category/category"].map((path) => (
          <Route
            path={path}
            element={
              <CategoryPublicContext>
                <CategoriesPublic />
              </CategoryPublicContext>
            }
          />
        ))}

        {/* Products */}
        {["/product", "/product/:category/category"].map((path) => (
          <Route
            path={path}
            element={
              <ProductPublicContext>
                <ProductsPublic />
              </ProductPublicContext>
            }
          />
        ))}

        {/* Product */}
        <Route
          path="/product/:product/product"
          element={
            <ProductPublicContext>
              <ProductPublic />
            </ProductPublicContext>
          }
        />

        {/* Payments */}
        {[
          "/payments",
          "/payments/:user/user",
          "/payments/:invoice/invoice",
        ].map((path) => (
          <Route
            path={path}
            element={
              <PaymentUserContext>
                <PaymentsUser />
              </PaymentUserContext>
            }
          />
        ))}

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </UserLayout>
  );
};

export default AdminContainer;
